import {ReactNode, useEffect, useRef, useState} from "react";

import {SetUserData, UserData, UserDataIFace} from "@/hooks/use-user-data-provider.ts";
import {useMeQuery} from "@/graphql/graphql.ts";
import {useAuth0} from "@auth0/auth0-react";
import {jwtDecode} from 'jwt-decode'
import * as Sentry from "@sentry/react";

export function UserDataProvider(
  {children}: { children: ReactNode },
) {
  const [userData, setUserDataProvider] = useState<UserDataIFace>(
    {permissions: [], isLoading: false},
  );
  
  
  const {isAuthenticated, user, getAccessTokenSilently, loginWithRedirect} = useAuth0();
  const me = useMeQuery(undefined, {
    enabled: isAuthenticated,
    throwOnError: false
  })
  console.log(isAuthenticated, user)
  
  // Update loading state when Me query is loading
  useEffect(() => {
    setUserDataProvider((prev) => ({
      ...prev,
      isLoading: me.isLoading
    }))
  }, [me.isLoading])
  
  useEffect(() => {
    if (me?.data?.me) {
      setUserDataProvider((prev) => ({
        ...prev,
        user: me.data.me
      }))
      
      Sentry.setUser({
        id: me.data.me.id,
        email: me.data.me.email,
        username: me.data.me.name,
        organizationId: me.data.me.organizationId,
        organization: me.data.me.organization?.name
      });
      
      console.log(me.data.me)
    }
  }, [me.data?.me])
  
  const isCalledRef = useRef(false);
  
  useEffect(() => {
    if (isAuthenticated && !isCalledRef.current) {
      getAccessTokenSilently({
        authorizationParams: {
          audience: "ai-zyusetu",
          organization: user?.org_id,
        }
      }).then(
        (token) => {
          const data = jwtDecode<{
            permissions: string[]
          }>(token)
          setUserDataProvider((prev) => ({
            ...prev,
            permissions: data.permissions
          }))
          isCalledRef.current = true;
        }
      ).catch(
        async (error) => {
          console.error(error)
          await loginWithRedirect({
            appState: {
              returnTo: window.location.pathname,
            }
          })
        }
      )
    }
  }, [getAccessTokenSilently, isAuthenticated, loginWithRedirect, me.data?.me, user?.org_id])
  
  return (
    <UserData.Provider value={userData}>
      <SetUserData.Provider value={setUserDataProvider}>
        {children}
      </SetUserData.Provider>
    </UserData.Provider>
  );
}
